import { useSignal } from '@preact/signals-react'
import { useEffect } from 'react'
import { getSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { scraperSiteSelected } from 'Pages/Admin/GlobalExecution/@signals'

export default function useScraperUserSearches() {
	const data = useSignal([])
	const isLoading = useSignal(false)

	useEffect(() => {
		if (!scraperSiteSelected.value) {
			data.value = []
			return
		}
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.MASTER_DATA}/admin/options/running-scraper-batch-searches-per-user?idSite=${scraperSiteSelected.value.idSite}`)
			.then(res => { data.value = res })
			.catch(() => { data.value = [] })
			.finally(() => { isLoading.value = false })
	}, [scraperSiteSelected.value])

	return {
		data: data.value,
		isLoading: isLoading.value,
		siteName: scraperSiteSelected.value?.name ?? '',
		onClose: () => { scraperSiteSelected.value = null },
	}
}